<template>
    <div class="modal-card" style="width:auto;">
        <header class="modal-card-head">
            <p class="modal-card-title">Product Details</p>
        </header>
        <section class="modal-card-body" style="padding-left:60px;padding-right:60px;">
            <figure class="image" style="width:256px;height:256px" v-if="product_details.product_image">
                <b-image :src="product_details.product_image" alt="A random image" ratio="5by5" :rounded="true">
                </b-image>
            </figure>
            <div class="control">
                <b-taglist attached>
                    <b-tag type="is-dark">Product Code</b-tag>
                    <b-tag type="is-info">{{ product_details.product_id }}</b-tag>
                </b-taglist>
            </div>
            <b-tooltip label="Product Name">
                <b-field :label="product_details.product_name" custom-class="has-text-primary is-large">
                </b-field>
            </b-tooltip>
            <br>
            <b-tooltip label="Product Family">
                <b-field :label="product_details.family_name" custom-class="is-medium">
                </b-field>
            </b-tooltip>
            <br>
            <b-tooltip label="Rack" v-if="product_details.rack">
               <b-field :label="product_details.rack" custom-class="is-medium">
            </b-field>
            </b-tooltip>
            <br>
            <b-taglist>
                <b-tag type="is-success">
                    <b-tooltip :label="`Purchase Price : ${product_details.retail_price_gamma}`">
                        {{product_details.retail_price_gamma_abstract_string}}</b-tooltip>
                </b-tag>
                <b-tag type="is-info">
                    <b-tooltip :label="`Wholesale Price : ${product_details.wholesale_price}`">
                        {{product_details.wholesale_price_abstract_string}}</b-tooltip>
                </b-tag>
                <b-tag type="is-danger">
                    <b-tooltip :label="`Retail Price (Type 1) : ${product_details.retail_price_alpha}`">
                        {{product_details.retail_price_alpha_abstract_string}}</b-tooltip>
                </b-tag>
                <b-tag type="is-warning" v-if="product_details.retail_price_beta">
                    <b-tooltip :label="`Retail Price (Type 2) : ${product_details.retail_price_beta}`">
                        {{product_details.retail_price_beta_abstract_string}}</b-tooltip>
                </b-tag>
            </b-taglist>
        </section>
        <footer class="modal-card-foot">
            <b-button class="button" @click="$parent.close()" icon-pack="fas" icon-right="fas fa-times"
                type="is-primary" expanded>
                Close</b-button>
        </footer>
    </div>
</template>

<script>
export default {
    name:"ProductDetails",
    props:{
        product_details:Object
    },
   
    data(){
        return {
            
        }
    },
    
}
</script>